import { Player } from "player";
import { prepVideoRoute, prepVideoView, VideoHeaderBlock, RelatedVideosBlock, } from ".";
export var VideoView = prepVideoView([
    // ProgramLinkBlock.block,
    VideoHeaderBlock.prepBlock(Player),
    RelatedVideosBlock.block,
]);
export var VideoViewWithoutPlayer = prepVideoView([
    // ProgramLinkBlock.block,
    RelatedVideosBlock.block,
]);
export var videoRoute = prepVideoRoute(VideoView);
export var videoRouteNoPlayer = prepVideoRoute(VideoViewWithoutPlayer);
export var VideoProvider = videoRoute.page;
